// @flow weak

import _ from 'lodash/fp';
import {addNotification} from './notification';
import {GET, PUT, POST, DELETE} from '../helpers/request';
import {ADDITIONAL} from '../assortments';

export const GET_REQUEST = '@purchaseOrderView/GET_REQUEST';
export const GET_SUCCESS = '@purchaseOrderView/GET_SUCCESS';
export const GET_FAILURE = '@purchaseOrderView/GET_FAILURE';

export const UPDATE_REQUEST = '@purchaseOrderView/UPDATE_REQUEST';
export const UPDATE_SUCCESS = '@purchaseOrderView/UPDATE_SUCCESS';
export const UPDATE_FAILURE = '@purchaseOrderView/UPDATE_FAILURE';

export const ADDITIONAL_ROW_UPDATE_REQUEST = '@purchaseOrderView/ADDITIONAL_ROW_UPDATE_REQUEST';
export const ADDITIONAL_ROW_UPDATE_SUCCESS = '@purchaseOrderView/ADDITIONAL_ROW_UPDATE_SUCCESS';
export const ADDITIONAL_ROW_UPDATE_FAILURE = '@purchaseOrderView/ADDITIONAL_ROW_UPDATE_FAILURE';

export const ADDITIONAL_ROW_CREATE_REQUEST = '@purchaseOrderView/ADDITIONAL_ROW_CREATE_REQUEST';
export const ADDITIONAL_ROW_CREATE_SUCCESS = '@purchaseOrderView/ADDITIONAL_ROW_CREATE_SUCCESS';
export const ADDITIONAL_ROW_CREATE_FAILURE = '@purchaseOrderView/ADDITIONAL_ROW_CREATE_FAILURE';

export const ADDITIONAL_ROW_REMOVE_REQUEST = '@purchaseOrderView/ADDITIONAL_ROW_REMOVE_REQUEST';
export const ADDITIONAL_ROW_REMOVE_SUCCESS = '@purchaseOrderView/ADDITIONAL_ROW_REMOVE_SUCCESS';
export const ADDITIONAL_ROW_REMOVE_FAILURE = '@purchaseOrderView/ADDITIONAL_ROW_REMOVE_FAILURE';

export const LINKED_ADDITIONAL_ROW_UPDATE_REQUEST = '@purchaseOrderView/LINKED_ADDITIONAL_ROW_UPDATE_REQUEST';
export const LINKED_ADDITIONAL_ROW_UPDATE_SUCCESS = '@purchaseOrderView/LINKED_ADDITIONAL_ROW_UPDATE_SUCCESS';
export const LINKED_ADDITIONAL_ROW_UPDATE_FAILURE = '@purchaseOrderView/LINKED_ADDITIONAL_ROW_UPDATE_FAILURE';

export const LINKED_ADDITIONAL_ROW_REMOVE_REQUEST = '@purchaseOrderView/LINKED_ADDITIONAL_ROW_REMOVE_REQUEST';
export const LINKED_ADDITIONAL_ROW_REMOVE_SUCCESS = '@purchaseOrderView/LINKED_ADDITIONAL_ROW_REMOVE_SUCCESS';
export const LINKED_ADDITIONAL_ROW_REMOVE_FAILURE = '@purchaseOrderView/LINKED_ADDITIONAL_ROW_REMOVE_FAILURE';

export const PRODUCTS_REQUEST = '@purchaseOrderView/PRODUCTS_REQUEST';
export const PRODUCTS_SUCCESS = '@purchaseOrderView/PRODUCTS_SUCCESS';
export const PRODUCTS_FAILURE = '@purchaseOrderView/PRODUCTS_FAILURE';

export const VARIANTS_REQUEST = '@purchaseOrderView/VARIANTS_REQUEST';
export const VARIANTS_SUCCESS = '@purchaseOrderView/VARIANTS_SUCCESS';
export const VARIANTS_FAILURE = '@purchaseOrderView/VARIANTS_FAILURE';

export const SET_ACTIVE_ADDITIONAL_ROW = '@purchaseOrderView/SET_ACTIVE_ADDITIONAL_ROW';
export const SET_ACTIVE_LINKED_ADDITIONAL_ROW = '@purchaseOrderView/SET_ACTIVE_LINKED_ADDITIONAL_ROW';

export const CLEAR = '@purchaseOrderView/CLEAR';

export const ORDER_ROW_UPDATE_REQUEST = '@purchaseOrderView/ORDER_ROW_UPDATE_REQUEST';
export const ORDER_ROW_UPDATE_SUCCESS = '@purchaseOrderView/ORDER_ROW_UPDATE_SUCCESS';
export const ORDER_ROW_UPDATE_FAILURE = '@purchaseOrderView/ORDER_ROW_UPDATE_FAILURE';

export const EXTRA_ROW_UPDATE_REQUEST = '@purchaseOrderView/EXTRA_ROW_UPDATE_REQUEST';
export const EXTRA_ROW_UPDATE_SUCCESS = '@purchaseOrderView/EXTRA_ROW_UPDATE_SUCCESS';
export const EXTRA_ROW_UPDATE_FAILURE = '@purchaseOrderView/EXTRA_ROW_UPDATE_FAILURE';

export const SET_NOTE_ROW = '@purchaseOrderView/SET_NOTE_ROW';

export const TOGGLE_REPORT_DIALOG = '@purchaseOrderView/TOGGLE_REPORT_DIALOG';
export const UPDATE_REPORT_FILTER = '@purchaseOrderView/UPDATE_REPORT_FILTER';

export const toggleReportDialog = (show: boolean) => ({
  type: TOGGLE_REPORT_DIALOG,
  show,
});

export const updateReportFilter = (supplierId: ?number, includePlans: boolean) => ({
  type: UPDATE_REPORT_FILTER,
  supplierId,
  includePlans,
});

export const setNoteRow = (row, isExtra = false) => ({
  type: SET_NOTE_ROW,
  row,
  isExtra,
});

const orderRowUpdateRequest = () => ({
  type: ORDER_ROW_UPDATE_REQUEST,
});

const orderRowUpdateSuccess = rows => ({
  type: ORDER_ROW_UPDATE_SUCCESS,
  rows,
});

const orderRowUpdateFailure = error => ({
  type: ORDER_ROW_UPDATE_FAILURE,
  error,
});

const orderDataRequest = () => ({
  type: GET_REQUEST,
});

const orderDataSuccess = (order, rooms) => ({
  type: GET_SUCCESS,
  order,
  rooms,
});

const orderDataFailure = error => ({
  type: GET_FAILURE,
  error,
});

const orderUpdateRequest = () => ({
  type: UPDATE_REQUEST,
});

const orderUpdateSuccess = order => ({
  type: UPDATE_SUCCESS,
  order,
});

const orderUpdateFailure = error => ({
  type: UPDATE_FAILURE,
  error,
});

const additionalRowUpdateRequest = () => ({
  type: ADDITIONAL_ROW_UPDATE_REQUEST,
});

const additionalRowUpdateSuccess = row => ({
  type: ADDITIONAL_ROW_UPDATE_SUCCESS,
  row,
});

const additionalRowUpdateFailure = error => ({
  type: ADDITIONAL_ROW_UPDATE_FAILURE,
  error,
});

const additionalRowCreateRequest = () => ({
  type: ADDITIONAL_ROW_CREATE_REQUEST,
});

const additionalRowCreateSuccess = (orderId, row) => ({
  type: ADDITIONAL_ROW_CREATE_SUCCESS,
  orderId,
  row,
});

const additionalRowCreateFailure = error => ({
  type: ADDITIONAL_ROW_CREATE_FAILURE,
  error,
});

const additionalRowRemoveRequest = () => ({
  type: ADDITIONAL_ROW_REMOVE_REQUEST,
});

const additionalRowRemoveSuccess = id => ({
  type: ADDITIONAL_ROW_REMOVE_SUCCESS,
  id,
});

const additionalRowRemoveFailure = error => ({
  type: ADDITIONAL_ROW_REMOVE_FAILURE,
  error,
});

const linkedAdditionalRowUpdateRequest = () => ({
  type: LINKED_ADDITIONAL_ROW_UPDATE_REQUEST,
});

const linkedAdditionalRowUpdateSuccess = row => ({
  type: LINKED_ADDITIONAL_ROW_UPDATE_SUCCESS,
  row,
});

const linkedAdditionalRowUpdateFailure = error => ({
  type: LINKED_ADDITIONAL_ROW_UPDATE_FAILURE,
  error,
});

const linkedAdditionalRowRemoveRequest = () => ({
  type: LINKED_ADDITIONAL_ROW_REMOVE_REQUEST,
});

const linkedAdditionalRowRemoveSuccess = id => ({
  type: LINKED_ADDITIONAL_ROW_REMOVE_SUCCESS,
  id,
});

const linkedAdditionalRowRemoveFailure = error => ({
  type: LINKED_ADDITIONAL_ROW_REMOVE_FAILURE,
  error,
});

const extraRowUpdateRequest = () => ({
  type: EXTRA_ROW_UPDATE_REQUEST,
});

const extraRowUpdateSuccess = row => ({
  type: EXTRA_ROW_UPDATE_SUCCESS,
  row,
});

const extraRowUpdateFailure = error => ({
  type: EXTRA_ROW_UPDATE_FAILURE,
  error,
});

const productsRequest = () => ({
  type: PRODUCTS_REQUEST,
});

const productsSuccess = products => ({
  type: PRODUCTS_SUCCESS,
  products,
});

const productsFailure = error => ({
  type: PRODUCTS_FAILURE,
  error,
});

const variantsRequest = () => ({
  type: VARIANTS_REQUEST,
});

const variantsSuccess = variants => ({
  type: VARIANTS_SUCCESS,
  variants,
});

const variantsFailure = error => ({
  type: VARIANTS_FAILURE,
  error,
});

export const setLinkedAdditionalRow = row => ({
  type: SET_ACTIVE_LINKED_ADDITIONAL_ROW,
  row,
});


export const setAdditionalProductRow = row => ({
  type: SET_ACTIVE_ADDITIONAL_ROW,
  row,
});

export const clear = () => ({
  type: CLEAR,
});

export const fetchOrderData = id => async dispatch => {
  dispatch(orderDataRequest());
  try {
    const order = await GET({endpoint: `/orders/${id}`}, dispatch);
    order.rows = await GET({endpoint: `/orders/${id}/rows`}, dispatch);
    order.additionalRows = await GET({endpoint: `/orders/${id}/additionalrows`}, dispatch);
    order.linkedAdditionalRows = await GET({endpoint: `/orders/${id}/linkedadditionalrows`}, dispatch);
    order.customRows = await GET({endpoint: `/orders/${id}/customrows`}, dispatch);
    order.extraRows = await GET({endpoint: `/orders/${id}/extrarows`}, dispatch);
    const apartmentConfig = await GET({endpoint: `/apartmentconfigs/${order.apartment.apartmentConfigId}`}, dispatch);
    dispatch(orderDataSuccess(order, apartmentConfig.rooms));
  } catch (err) {
    dispatch(orderDataFailure(err));
  }
};

export const updateOrder = (id, body) => async dispatch => {
  dispatch(orderUpdateRequest());
  try {
    const order = await PUT({
      endpoint: `/orders/${id}`,
      body,
    }, dispatch);
    dispatch(orderUpdateSuccess(order));
    dispatch(addNotification('Beställning uppdaterad', 'success'));
  } catch (err) {
    dispatch(orderUpdateFailure(err));
  }
};

export const fetchProducts = () => async dispatch => {
  dispatch(productsRequest());
  try {
    const products = await GET({endpoint: '/products'}, dispatch);
    const additionalProducts = _.filter({assortment: ADDITIONAL}, products);
    dispatch(productsSuccess(additionalProducts));
  } catch (err) {
    dispatch(productsFailure(err));
  }
};

export const fetchVariants = id => async dispatch => {
  dispatch(variantsRequest());
  try {
    const variants = await GET({endpoint: `/products/${id}/variants`}, dispatch);
    dispatch(variantsSuccess(variants));
  } catch (err) {
    dispatch(variantsFailure(err));
  }
};

export const createAdditionalRow = (orderId, body) => async dispatch => {
  dispatch(additionalRowCreateRequest());
  try {
    const row = await POST({
      endpoint: `/orders/${orderId}/additionalrows`,
      body,
    }, dispatch);
    dispatch(additionalRowCreateSuccess(orderId, row));
    dispatch(addNotification('Tilläggsprodukt tillagd', 'success'));
  } catch (err) {
    dispatch(additionalRowCreateFailure(err));
  }
};

export const updateAdditionalRow = (id, body) => async dispatch => {
  dispatch(additionalRowUpdateRequest());
  try {
    const row = await PUT({
      endpoint: `/additionalorderrows/${id}`,
      body,
    }, dispatch);
    dispatch(additionalRowUpdateSuccess(row));
    dispatch(addNotification('Tilläggsprodukt uppdaterad', 'success'));
  } catch (err) {
    dispatch(additionalRowUpdateFailure(err));
  }
};

export const removeAdditionalRow = rowId => async dispatch => {
  dispatch(additionalRowRemoveRequest());
  try {
    await DELETE({
      endpoint: `/additionalorderrows/${rowId}`,
    }, dispatch);
    dispatch(additionalRowRemoveSuccess(rowId));
    dispatch(addNotification('Tilläggsprodukt borttagen', 'success'));
  } catch (err) {
    dispatch(additionalRowRemoveFailure(err));
  }
};

export const updateLinkedAdditionalRow = (id, body) => async dispatch => {
  dispatch(linkedAdditionalRowUpdateRequest());
  try {
    const row = await PUT({
      endpoint: `/linkedadditionalrows/${id}`,
      body,
    }, dispatch);
    dispatch(linkedAdditionalRowUpdateSuccess(row));
    dispatch(addNotification('Tilläggsprodukt uppdaterad', 'success'));
  } catch (err) {
    dispatch(linkedAdditionalRowUpdateFailure(err));
  }
};

export const removeLinkedAdditionalRow = rowId => async dispatch => {
  dispatch(linkedAdditionalRowRemoveRequest());
  try {
    await DELETE({
      endpoint: `/linkedadditionalrows/${rowId}`,
    }, dispatch);
    dispatch(linkedAdditionalRowRemoveSuccess(rowId));
    dispatch(addNotification('Tilläggsprodukt borttagen', 'success'));
  } catch (err) {
    dispatch(linkedAdditionalRowRemoveFailure(err));
  }
};

export const updateOrderRow = (id, body) => async dispatch => {
  dispatch(orderRowUpdateRequest());
  try {
    const rows = await PUT({
      endpoint: `/orderrows/${id}`,
      body,
    }, dispatch);
    dispatch(orderRowUpdateSuccess(rows));
    dispatch(addNotification('Anteckning uppdaterad', 'success'));
  } catch (err) {
    dispatch(orderRowUpdateFailure(err));
  }
};

export const updateExtraRow = (id, body) => async dispatch => {
  dispatch(extraRowUpdateRequest());
  try {
    const row = await PUT({
      endpoint: `/extraorderrows/${id}`,
      body,
    }, dispatch);
    dispatch(extraRowUpdateSuccess(row));
    dispatch(addNotification('Anteckning uppdaterad', 'success'));
  } catch (err) {
    dispatch(extraRowUpdateFailure(err));
  }
};



// WEBPACK FOOTER //
// ./src/actions/purchaseOrderView.js